const LOGO_WHITE = "https://customer-assets.emergentagent.com/job_honor-platform-2/artifacts/ynn204xu_Isologo%20%283%29%20-%20copia.png";
const LOGO_GOLD = "https://customer-assets.emergentagent.com/job_honor-platform-2/artifacts/y8mqefft_Honor%20Trading%20-%20Gold%20-%20Logo%20ready.png";

export const HonorLogo = ({ className = "h-10 w-auto", variant = "white" }) => {
  const src = variant === "gold" ? LOGO_GOLD : LOGO_WHITE;
  return (
    <img
      src={src}
      alt="Honor Trading"
      className={`${className} object-contain select-none`}
      draggable={false}
      data-testid="honor-logo"
    />
  );
};

export default HonorLogo;
